<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-form-group
        id="input-group-1"
        label-align="left"
        label="¿Cuál es el motivo de la solicitud?"
        label-for="input-1"
    >
      <b-form-textarea v-if="!desdeLista"
          v-model="cuestionario.motivoSolicitud"
          placeholder="Describe el motivo de la solicitud..."
          rows="3"
          max-rows="6"
      ></b-form-textarea>
      <p v-else>
        {{cuestionario.motivoSolicitud}}
      </p>
    </b-form-group>

    <b-form-group
        id="input-group-1"
        label-align="left"
        label="Fecha de inicio del tratamiento"
        label-for="input-1"
    >
      <b-form-datepicker
          :readonly="desdeLista"
          locale="es-MX"
          labelNoDateSelected="Seleccione una fecha"
          :max="new Date()"
          v-model="cuestionario.fechaTratamiento"
      ></b-form-datepicker>
    </b-form-group>

    <b-form-group
        id="input-group-1"
        label-align="left"
        label="¿En que consistió el tratamiento?"
        label-for="input-1"
    >
      <b-form-textarea
          v-if="!desdeLista"
          v-model="cuestionario.consistenciaTratamiento"
          placeholder="Describe el tratamiento..."
          rows="3"
          max-rows="6"
      ></b-form-textarea>
      <p v-else>
        {{cuestionario.consistenciaTratamiento}}
      </p>
    </b-form-group>

    <b-form-group
        id="input-group-1"
        label-align="left"
        label="¿Cuál es el avance del tratamiento?"
        label-for="input-1"
    >
      <b-form-textarea
          v-if="!desdeLista"
          v-model="cuestionario.avanceTratamiento"
          placeholder="Describe el avance..."
          rows="3"
          max-rows="6"
      ></b-form-textarea>
      <p v-else>
        {{cuestionario.avanceTratamiento}}
      </p>
    </b-form-group>

    <div v-if="!desdeLista">
      <b-form-checkbox

          id="checkbox-1"
          v-model="cuestionario.seguimientoDentalia"
          class="mb-3"
      >
        ¿Se seguirá atendiendo en Dentalia?
      </b-form-checkbox>
    </div>

    <div v-else>
      <b-form-group
          id="input-group-1"
          label-align="left"
          label="¿Se seguirá atendiendo en Dentalia?"
          label-for="input-1"
      >
        <p v-if="cuestionario.seguimientoDentalia">
          Si
        </p>
        <p v-else>
          No
        </p>
      </b-form-group>
    </div>


    <b-form-group
        id="input-group-1"
        label-align="left"
        label="Del monto a devolver, ¿para qué tratamientos eran y no se
              realizaron? Detallar el tratamiento con el número del OD"
        label-for="input-1"
    >
      <b-form-textarea
          v-if="!desdeLista"
          v-model="cuestionario.detalle"
          placeholder="Describe el detalle..."
          rows="3"
          max-rows="6"
      ></b-form-textarea>
      <p v-else>
        {{cuestionario.detalle}}
      </p>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "FormCuestionarioLegal",
  props:{
    cuestionario: Object,
    desdeLista: Boolean
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
}
</script>

<style scoped>

</style>
